export const API_ERRORS: { [key: number]: string } = {
  3: 'Não existe usuário neste departamento',
  21: 'Já existe uma jornada para este segmento',
  25: 'Já existe uma etapa com este nome',
  26: 'Conclua a etapa bloqueante antes de avançar',
  27: 'Anexe pelo menos um arquivo para concluir esta etapa',
  40: 'Este CNPJ já está sendo utilizado',
  50: 'Já existe um segmento com este nome',
  55: 'Já existe uma origem com este nome',
  60: 'Este número já está sendo utilizado',
  61: 'Este número não está vinculado à uma conta Whatsapp',
  62: 'Contato bloqueado',
  63: 'Não foi possível validar o número no WhatsApp. Tente novamente.',
  64: 'O contato ou grupo não foi encontrado. Atualize a página e tente novamente.',
  65: 'O cliente de destino não foi encontrado. Atualize a página e tente novamente.',
  66: 'O contato ou grupo já pertence ao cliente selecionado.',
  67: 'O cliente de destino já possui um contato ou grupo com este número.',
  70: 'Já existe um tutorial para esta página',
  80: 'Já existe uma lista de transmissão com esse nome.',
  81: 'A lista excede o limite permitido de contatos.',
  85: 'Este lote não pode mais ser editado porque já saiu do estado pendente.',
  86: 'Já existe outro disparo em andamento para este número.',
  87: 'O disparo está bloqueado até regularizar o estado operacional do número.',
  88: 'Ainda existem mensagens na fila da z-api. Limpe a fila antes de retomar.',
  89: 'Esta ação não é permitida no estado atual do lote.',
  93: 'O número do WhatsApp está desconectado no momento. Reconecte antes de iniciar o disparo.',
  94: 'Revise as credenciais da integração do WhatsApp e tente novamente.',
  90: 'Este número já está configurado para outra empresa',
  91: 'Configuração de API não encontrada, contate o suporte',
  92: 'Primeiro cadastre o número de WhatsApp da conta',
  95: 'A janela de conversa está fechada. Envie um template aprovado para iniciar ou retomar o atendimento.',
  96: 'Template indisponível. Sincronize os templates e selecione um template aprovado.',
  97: 'Template não encontrado.',
  98: 'Somente templates em rascunho podem ser editados.',
  99: 'Revise os componentes, variáveis e exemplos do template.',
  1000: 'Já existe um template com este nome e idioma.',
  1001: 'A Meta não concluiu a operação. Tente novamente ou verifique a configuração da conta.',
  1002: 'O contato desta conversa não possui um telefone válido para receber o template.',
  1003: 'Configure os dados de pagamento da conta do WhatsApp Business na Meta antes de enviar templates ou iniciar campanhas.',
  1004: 'A mensagem do template não pode começar nem terminar com uma variável.',
  1005: 'A categoria de um template aprovado não pode ser alterada. Mantenha a categoria atual ou clone o template para criar um novo.',
  1006: 'Configure e conecte uma API não oficial antes de habilitar a API oficial. Ela é necessária para fotos, contatos e grupos.',
  1007: 'A rota selecionada não possui uma integração configurada. Revise as rotas de mensagens e transmissões.',
  1008: 'O transporte selecionado para esta operação não está configurado ou está desativado.',
  1009: 'A API oficial só pode ser configurada pelo onboarding seguro da Meta.',
  1010: 'Esta empresa não possui uma API oficial ativa para desvincular.',
  1011: 'Configure e ative a API oficial do WhatsApp antes de criar uma campanha.',
  1012: 'O template selecionado não está disponível ou não está aprovado para esta integração.',
  1013: 'Escolha uma data e hora futura para agendar a campanha.',
  1014: 'Preencha todas as variáveis manuais do template antes de continuar.',
  1015: 'O template selecionado não aceita mídia.',
  1016: 'Selecione uma mídia específica para este envio.',
  1017: 'O arquivo de exemplo usado na aprovação do template não pode ser enviado na campanha. Selecione outro arquivo.',
  1018: 'A mídia selecionada é inválida ou não pertence a esta empresa.',
  1019: 'O formato da mídia selecionada não corresponde ao cabeçalho do template.',
  1020: 'Esta campanha não pode ser pausada no estado atual.',
  1021: 'Esta campanha não está pausada.',
  1022: 'Esta campanha já foi encerrada.',
  1023: 'A lista selecionada não foi encontrada. Atualize a página e tente novamente.',
  1024: 'A campanha não foi encontrada ou não pertence à sua empresa.',
  1025: 'Esta empresa utiliza a API oficial. Faça o disparo pela tela de Campanhas.',
  1026: 'Esta campanha já iniciou e não pode mais ter o agendamento alterado.',
  1027: 'Para listas de transmissão com API oficial, o agendamento deve usar um template aprovado.',
  1028: 'Templates de autenticação não podem ser utilizados em listas de transmissão ou campanhas.',
  1029: 'O envio de templates no atendimento está desabilitado porque esta integração utiliza a API não oficial no atendimento 1:1.',
  101: 'Selecione um arquivo de imagem válido para a foto de perfil',
  102: 'A foto de perfil excede o tamanho máximo permitido',
  110: 'Já existe um plano para este preço',
  111: 'Número máximo de usuários atingido para este plano',
  130: 'Mensagem não encontrada',
  131: 'Mensagem já removida',
  132: 'Você não tem permissão para remover esta mensagem',
  133: 'Este áudio não pode ser transcrito.',
  134: 'O arquivo de áudio ainda não está disponível.',
  135: 'A franquia mensal de transcrição foi atingida.',
  136: 'A transcrição está indisponível no momento. Tente novamente.',
  137: 'A transcrição de áudios ainda não está habilitada para esta empresa.',
  140: 'A data limite deve ser maior ou igual à data de envio.',
  141: 'A data limite deve ser maior ou igual a hoje.',
  142: 'Selecione um contato ou uma lista de transmissão para agendar a mensagem.',
  170: 'O cliente pertence a um segmento diferente da jornada atual',
  171: 'O tipo do cliente não é compatível com o porte selecionado',
  172: 'Nenhum cliente selecionado foi encontrado.',
  173: 'Alguns clientes selecionados não foram encontrados. Atualize a lista e tente novamente.',
  174: 'Uma ou mais tags selecionadas não foram encontradas. Atualize a página e tente novamente.',
  175: 'O departamento selecionado nao condiz com o departamento do atendente selecionado.',
  176: 'Seu usuário não está associado a este departamento. Faça login novamente para carregar suas novas permissões.',
  177: 'Este cliente está em processo de remoção. Aguarde a conclusão para realizar novas ações.',
  178: 'Registre o cliente em uma etapa da jornada antes de comentar.',
  179: 'Clientes inativos, não clientes e não identificados não participam de jornadas',
  180: 'Já existe um usuário com este e-mail',
  181: 'A empresa precisa ter pelo menos um administrador ativo.',
  182: 'Este link é inválido ou já foi utilizado. Solicite um novo link.',
  183: 'As senhas informadas não são iguais.',
  190: 'O supervisor não pode ser o mesmo responsável pela ordem de serviço.',
  191: 'Essa ordem de serviço só pode ser editada antes de iniciar ou após reprovação.',
  192: 'A transição de status informada não é válida para o estado atual da ordem de serviço.',
  193: 'Você não tem permissão para executar essa ação nesta ordem de serviço.',
  194: 'Defina um supervisor para continuar com essa ação.',
  195: 'Comentário de supervisor obrigatório para reprovar ordem de serviço.',
  200: 'Já existe um horário de expediente para este escopo.',
  210: 'A API key do Acessórias é inválida.',
  211: 'Configure a API key do Acessórias no seu usuário.',
  212: 'Período de consulta inválido.',
  213: 'Período de início do processo inválido.',
  214: 'Período de conclusão do processo inválido.',
  220: 'As credenciais do G-Click são inválidas.',
  221: 'Configure a integração com o G-Click para continuar.',
  222: 'Este cliente ainda não está vinculado ao G-Click.',
  223: 'O cliente não foi encontrado no G-Click.',
  224: 'Este cliente do G-Click já está vinculado a outro cliente.',
  225: 'O período informado para consultar tarefas é inválido.',
  226: 'O limite de consultas do G-Click foi atingido. Tente novamente em instantes.',
  227: 'O G-Click está indisponível no momento. Tente novamente.',
  228: 'Informe as duas credenciais do G-Click ou apague ambas para remover a configuração.',
  229: 'A tarefa não foi encontrada no G-Click.',
  230: 'O arquivo da atividade não foi encontrado no G-Click.',
  231: 'O arquivo da atividade excede o limite permitido.',
  232: 'O departamento não foi encontrado no G-Click. Atualize a lista e tente novamente.',
  233: 'Selecione um processo para o departamento informado.',
  234: 'O processo não pertence ao departamento selecionado. Atualize a lista e tente novamente.',
  235: 'O G-Click rejeitou os dados da pré-tarefa. Revise os campos e tente novamente.',
  240: 'As credenciais do Omie são inválidas.',
  241: 'O Omie bloqueou temporariamente novas consultas. Tente novamente mais tarde, pois novas tentativas durante esse período podem prolongar o bloqueio.',
  242: 'O Omie está indisponível no momento. Tente novamente.',
  243: 'Informe as duas credenciais do Omie ou apague ambas para remover a configuração.',
  244: 'O cliente não foi encontrado no Omie. Altere o vínculo para continuar.',
  245: 'Este cliente ainda não está vinculado ao Omie.',
  246: 'A conta a receber não foi encontrada no Omie.',
  247: 'Esta conta a receber não possui boleto disponível.',
  248: 'O anexo não foi encontrado no Omie.',
  249: 'O arquivo do Omie excede o limite permitido.',
  250: 'O período informado para consultar os títulos é inválido.',
  251: 'A conta a pagar não foi encontrada no Omie.',
  252: 'Defina dias e limites positivos e mantenha pelo menos um gatilho habilitado.',
  253: 'Os dados financeiros retornados pelo Omie estão incompletos ou inconsistentes. Nenhum status foi atualizado.',
  254: 'A sincronização de status Omie ainda não está habilitada.',
  255: 'Uma atualização Omie já está em andamento. Aguarde e tente novamente.',
  256: 'As credenciais ou a data de apuração mudaram durante a execução. Inicie uma nova atualização.',
  257: 'Não foi possível verificar a execução Omie. Tente acompanhar novamente.',
  258: 'Esta tentativa foi substituída por outra execução. Atualize o acompanhamento.',
  259: 'A execução Omie possui dados incompatíveis. Solicite uma nova atualização.',
  260: 'A indicação de uma comissão paga só pode ser alterada após o estorno.',
  270: 'Uma ou mais demandas selecionadas não foram encontradas. Atualize a lista e tente novamente.',
  271: 'Uma ou mais demandas ainda têm vínculos que impedem a remoção. Atualize a lista e entre em contato com o suporte se o problema continuar.',
}

export const EXISTING_CONVERSATION = 2
export const NO_ACTIVE_USERS_IN_DEPARTMENT = 3
export const JOURNEY_STAGE_BLOCKED = 26
export const JOURNEY_STAGE_ATTACHMENT_REQUIRED = 27
